import { Link } from "react-router-dom";
import "./CodeRedactorPage.css";

function CodeRedactorPage() {
    return (
        <div className="code-redactor-page">
            <div className="code-redactor-hero">
                <div className="code-redactor-hero__badge">Making Sense</div>
                <h1 className="code-redactor-hero__title">More about code redaction</h1>
                <p className="code-redactor-hero__subtitle">
                    A structured way to clean up, refactor, and modernize codebases while keeping behavior intact and
                    making the project easier to extend.
                </p>

                <div className="code-redactor-hero__actions">
                    <Link to="/contact" className="code-redactor-hero__button">
                        Request a consultation
                    </Link>
                </div>
            </div>

            <div className="code-redactor-content">
                <section className="code-redactor-section">
                    <h2 className="code-redactor-section__title">What it does</h2>
                    <p className="code-redactor-section__text">
                        We improve your code without breaking it: we reorganize logic, tighten structure, and align the
                        code with modern standards so future changes are faster and safer.
                    </p>
                </section>

                <section className="code-redactor-section">
                    <h2 className="code-redactor-section__title">Key steps</h2>
                    <div className="code-redactor-grid">
                        <div className="code-redactor-card">
                            <h3 className="code-redactor-card__title">Audit</h3>
                            <p className="code-redactor-card__text">We identify hotspots, technical debt, and risky areas.</p>
                        </div>
                        <div className="code-redactor-card">
                            <h3 className="code-redactor-card__title">Refactor</h3>
                            <p className="code-redactor-card__text">We restructure modules and improve readability.</p>
                        </div>
                        <div className="code-redactor-card">
                            <h3 className="code-redactor-card__title">Modernize</h3>
                            <p className="code-redactor-card__text">We update patterns and tooling for maintainability.</p>
                        </div>
                        <div className="code-redactor-card">
                            <h3 className="code-redactor-card__title">Stabilize</h3>
                            <p className="code-redactor-card__text">We verify behavior with tests and careful checks.</p>
                        </div>
                    </div>
                </section>

                <section className="code-redactor-section code-redactor-section_cta">
                    <h2 className="code-redactor-section__title">Need this for your project?</h2>
                    <p className="code-redactor-section__text">
                        Tell us what your codebase looks like today and what you want to achieve — we’ll propose a
                        concrete plan and scope.
                    </p>
                    <div className="code-redactor-section_cta__actions">
                        <Link to="/contact" className="code-redactor-hero__button code-redactor-hero__button_secondary">
                            Discuss the project
                        </Link>
                    </div>
                </section>
            </div>
        </div>
    );
}

export default CodeRedactorPage;

